class HandValuation {
  constructor(wasmResult) {
    const row = wasmResult.split('$')
    this.payout = parseInt(row[0]);
    this.ppRank = row[1];
    // TODO add vpfree2 rank ?
  }
  toString() {
    return `$${this.payout} [${this.ppRank}]`
  }
}

export default HandValuation